module.exports = __webpack_public_path__ + "static/media/ExamSet.748aa4d0.svg";